/* src/app/bulk-client/bulk-client.component.scss */
.bulk-import {
  background: white;
  padding: 20px;
  border-radius: 20px;
  color: black;
}
.bulk-import select {
  width: 100%;
  padding: 5px;
}
.bulk-import {
  text-align: left;
}
.bulk-import p {
  margin-bottom: 10px;
}
.bulk-import p a {
  border-bottom: 1px #ccc dashed;
}
.bulk-import h2 {
  font-size: 1.1rem;
  margin-bottom: 10px;
  text-align: center;
}
.errors {
  margin-top: 20px;
}
.errors ul {
  margin: 20px 0;
  padding: 0px 20px;
}
.importButtons {
  text-align: center;
}
.processing {
  text-align: center;
}
/*# sourceMappingURL=bulk-client.component.css.map */
